import { QueryClient } from '@tanstack/react-query';

// Create and configure QueryClient with sensible defaults
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            cacheTime: 1000 * 60 * 30, // 30 minutes
            retry: 1,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true
        },
        mutations: {
            retry: 0
        }
    }
});

// Query key factory for tasks
export const taskKeys = {
    all: ['tasks'],
    lists: () => [...taskKeys.all, 'list'],
    list: (filters) => [...taskKeys.lists(), { filters }],
    details: () => [...taskKeys.all, 'detail'],
    detail: (id) => [...taskKeys.details(), id]
};

// Query key factory for templates
export const templateKeys = {
    all: ['templates'],
    lists: () => [...templateKeys.all, 'list'],
    list: (filters) => [...templateKeys.lists(), { filters }],
    details: () => [...templateKeys.all, 'detail'],
    detail: (id) => [...templateKeys.details(), id]
};

// Query key factory for billing
export const billingKeys = {
    all: ['billing'],
    subscription: (scope = 'current') => [...billingKeys.all, 'subscription', scope],
};

// Query key factory for organization profile
export const organizationKeys = {
    all: ['organization'],
    my: () => [...organizationKeys.all, 'my'],
    openLaborEpisodes: () => [...organizationKeys.all, 'open-labor-episodes'],
};

// Query key factory for dashboard cards
export const dashboardKeys = {
    all: ['dashboard'],
    chartsNeedingSignature: (filters) => [...dashboardKeys.all, 'charts-needing-signature', { filters }],
};

// Query key factory for automations
export const automationKeys = {
    all: ['automations'],
    lists: () => [...automationKeys.all, 'list'],
    list: () => [...automationKeys.lists()]
};

export const appointmentTypeCatalogKeys = {
    all: ['appointmentTypeCatalog'],
    customTypes: () => [...appointmentTypeCatalogKeys.all, 'customTypes'],
    presetVisibility: () => [...appointmentTypeCatalogKeys.all, 'presetVisibility'],
};
